export const instantAnimationState = {
    current: false,
}
